import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  setactionType,
  setInterVal,
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../../redux/slice/DashBoardSlice";
import { useDispatch } from "react-redux";
import AccordionComponent from "../../../../../common/Accordion";
import MonthIntervalDropdown from "../../../../../common/MonthIntervalDropdown";
import { Card, Col, Row } from "react-bootstrap";
import CommonProgressBar from "../CommonProgressBar";
import { getRORCaseActionsSummary } from "../../../../../services/RORDashboardAPI";
import { WEB_ROLE } from "../../../../../common/Constant";
import { getHistorianCaseActionsSummary } from "../../../../../services/HistorianDashboardAPI";
import { getEditorCaseActions } from "../../../../../services/EditorDashboardAPI";
import { getTranscriberCaseActionsSummary } from "../../../../../services/TranscriberDashboardAPI";

interface ResultProps {
  onTabChange: () => void;
  openDropdown: string | null;
  setOpenDropdown: React.Dispatch<React.SetStateAction<string | null>>;
  userRole?: any;
}
const RORCaseActionSummary: React.FC<ResultProps> = ({
  onTabChange,
  openDropdown,
  setOpenDropdown,
  userRole,
}) => {
  const dispatch = useDispatch();

  const [interval, setInterval] = useState<string>("1");
  const [intervalLabel, setIntervalLabel] = useState<string>("This Month");
  const [caseActions, setCaseActions] = useState<any[]>([]);

  const fetchCaseActions = async () => {
    try {
      let response;

      switch (userRole) {
        case WEB_ROLE.Record_Reviewer:
          response = await getRORCaseActionsSummary(interval);
          break;

        case WEB_ROLE.Historian:
          response = await getHistorianCaseActionsSummary(interval);
          break;

        case WEB_ROLE.Editor:
          response = await getEditorCaseActions(interval);
          break;

        case WEB_ROLE.Transcriber:
          response = await getTranscriberCaseActionsSummary(interval);
          break;

        default:
          response = [];
      }

      setCaseActions(response);
    } catch (error) {
      console.error("Failed to fetch case actions:", error);
    }
  };

  const getValueByType = (type: string) =>
    caseActions.find((a) => a.actionType === type)?.actionTypeCount || 0;

  const [CaseActionKey, setCaseActionKey] = useState<string | null>("0");

  const handleBodyAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (CaseActionKey === key) {
      return; // do nothing
    }
    setCaseActionKey(key || "0");
  };

  const CaseActionAccordion = (
    items: { title: JSX.Element; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={CaseActionKey}
      onSelect={handleBodyAccordionSelect}
    />
  );

  const handleIntervalChange = (
    intervalValue: string | number,
    label: string,
  ) => {
    setInterval(String(intervalValue));
    setIntervalLabel(label);
  };
  const getCaseInfoIdsByType = (type: string): number[] => {
    const ids = caseActions.find((a) => a.actionType === type)?.caseInfoIds;
    return ids ? ids.split(",").map((id: any) => Number(id.trim())) : [];
  };

  useEffect(() => {
    fetchCaseActions();
  }, [interval]);

  const handleCardClick = (type: string) => {
    // const ids = getCaseInfoIdsByType(type);
    // dispatch(setInterVal(Number(interval)));
    // dispatch(setNewCaseInFoID(ids));
    // setTimeout(() => {
    //   onTabChange();
    // }, 800);
  };

  const historyPercentage = "80%";
  const RorPercentage = "65%";
  const EditorPercentage = "20%";

  const totalPagesConfig = {
    [WEB_ROLE.Record_Reviewer]: {
      title: "Total Pages",
      leftLabel: "Received",
      rightLabel: "Reviewed",
      leftKey: "Total Pages Received",
      rightKey: "Total Pages Reviewed",
    },

    [WEB_ROLE.Historian]: {
      title: "History Calls",
      leftLabel: "Scheduled",
      rightLabel: "Not Scheduled",
      leftKey: "Scheduled",
      rightKey: "Not Scheduled",
    },

    [WEB_ROLE.Editor]: {
      title: "Editing",
      leftLabel: "Not Initiated",
      rightLabel: "Ongoing",
      leftKey: "Editing Pending",
      rightKey: "Editing In Progress",
    },

    [WEB_ROLE.Transcriber]: {
      title: "Transcription",
      leftLabel: "Not Initiated",
      rightLabel: "Ongoing",
      leftKey: "Transcription Pending",
      rightKey: "Transcription In Progress",
    },
  };

  const currentConfig =
    totalPagesConfig[userRole] || totalPagesConfig[WEB_ROLE.Record_Reviewer];

  const completedConfig = {
    [WEB_ROLE.Record_Reviewer]: {
      label: "ROR Completed",
      key: "ROR Completed",
    },

    [WEB_ROLE.Historian]: {
      label: "History Completed",
      key: "History Completed",
    },

    [WEB_ROLE.Editor]: {
      label: "QME Reports Completed",
      key: "Editing Completed",
    },

    [WEB_ROLE.Transcriber]: {
      label: "Transcription Completed",
      key: "Transcription Completed",
    },
  };

  const currentCompletedConfig =
    completedConfig[userRole] || completedConfig[WEB_ROLE.Record_Reviewer];

  return (
    <>
      {CaseActionAccordion([
        {
          title: (
            <div className="d-flex justify-content-between align-items-center w-100 p-0">
              <span className="">Case Actions</span>
              <MonthIntervalDropdown
                title={intervalLabel}
                onSelect={handleIntervalChange}
                stopPropagation={true}
                show={openDropdown === "RORActionMonth"}
                onToggle={(isOpen) =>
                  setOpenDropdown(isOpen ? "RORActionMonth" : null)
                }
              />
            </div>
          ),
          content: (
            <>
              <div>
                <Row className="g-3 ">
                  <Col md={6}>
                    <Card
                      className="border-0 h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#d6f2fe",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body className="p-3">
                        {/* Header */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="fw-bold cardTite_inf">
                            {currentConfig.title}
                          </span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#0e99d7" }}
                          >
                            medical_services
                          </span>
                        </div>

                        {/* Two Column Section */}
                        <div className="d-flex">
                          {/* Left Section */}
                          <div className="flex-fill pe-2">
                            <div
                              className="small text-muted mb-1"
                              style={{ color: "#0e99d7" }}
                            >
                              {currentConfig.leftLabel}
                            </div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#0e99d7" }}
                            >
                              {getValueByType(currentConfig.leftKey)}
                            </h5>
                          </div>

                          {/* Divider */}
                          <div
                            style={{
                              width: "1px",
                              backgroundColor: "#9b6d15",
                            }}
                          />

                          {/* Right Section */}
                          <div className="flex-fill ps-2">
                            <div
                              className="small text-muted mb-1"
                              style={{ color: "#0e99d7" }}
                            >
                              {currentConfig.rightLabel}
                            </div>
                            <h5
                              className="fw-bold mb-0 text-start"
                              style={{ color: "#0e99d7" }}
                            >
                              {getValueByType(currentConfig.rightKey)}
                            </h5>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card
                      className="border-0 h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#ddfcdd",
                        borderRadius: "8px",
                      }}
                      onClick={() =>
                        handleCardClick(currentCompletedConfig.key)
                      }
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold cardTite_inf">
                            {currentCompletedConfig.label}
                          </span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#008400" }}
                          >
                            bookmark_check
                          </span>
                        </div>

                        <h4
                          className="fw-bold mb-0"
                          style={{ color: "#008400" }}
                        >
                          {getValueByType(currentCompletedConfig.key)}
                        </h4>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row className="g-3 mt-3">
                  <Col md={6}>
                    <Card
                      className="border-0  h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#fbb3b4",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleCardClick("Closed Cases")}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold cardTite_inf">Overdue</span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#ee3036" }}
                          >
                            shield_question
                          </span>
                        </div>

                        <h4
                          className="fw-bold mb-0"
                          style={{ color: "#ee3036" }}
                        >
                          {getValueByType("Overdue")}
                        </h4>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#ee3036",
                          }}
                        ></span>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card
                      className="border-0  h-100"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#fdecbe",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleCardClick("Closed Cases")}
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold cardTite_inf">
                            Avg Processing
                          </span>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#956409" }}
                          >
                            hourglass
                          </span>
                        </div>
                        <h4
                          className="fw-bold mb-0"
                          style={{ color: "#956409" }}
                        >
                          {getValueByType("Avg Processing (Days)")}
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#000",
                              fontWeight: "normal",
                              marginLeft: "4px",
                            }}
                          >
                            Days
                          </span>
                        </h4>
                        <span style={{ fontSize: "13px", color: "#6c757d" }}>
                          Per Case
                        </span>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </>
          ),
        },
      ])}
    </>
  );
};

export default RORCaseActionSummary;
